import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SimilarInboundFaxState } from 'app/capture-admin/pages/capture-admin-inbound-fax/capture-admin-inbound-fax.component';

import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-inbound-fax-duplicate-check',
    templateUrl: './inbound-fax-duplicate-check.component.html',
    styleUrls: ['./inbound-fax-duplicate-check.component.scss'],
    imports: [MatProgressSpinner, MatIcon, MatTooltip]
})
export class InboundFaxDuplicateCheckComponent {

  @Input() similarInboundFaxState = new SimilarInboundFaxState();
  @Output() reviewDocumentsClicked = new EventEmitter<void>;

  onReviewDuplicatesClick() {
    this.reviewDocumentsClicked.emit();
  }

  get shouldHighlight() {
    return this.similarInboundFaxState.similarInboundFaxes.length > 0 &&
      !this.similarInboundFaxState.warningDismissed;
  }
}
